// This file is automatically generated. Do not edit manually.

import { SalesPart } from "src/api/generated/erp/db/types/tables/salesPart";
import { SalesPartUpdateService_UpdateRequest } from "src/api/generated/erp/sales/masterData/service/salesPartUpdateService";
import { ObjectAccountingDimensionValue } from "src/api/generated/erp/common/accounting/objectAccountingDimensionValue";
import { ErpUnit } from "src/api/generated/erp/db/types/tables/erpUnit";
import { SalesPartImportCode } from "src/api/generated/erp/db/types/tables/salesPartImportCode";
import { PartView } from "src/api/generated/erp/db/types/tables/partView";
import { SalesPartCategory } from "src/api/generated/erp/db/types/tables/salesPartCategory";
import { SalesPartPriceGroup } from "src/api/generated/erp/db/types/tables/salesPartPriceGroup";
import { Site } from "src/api/generated/erp/db/types/tables/site";
import { VatCode } from "src/api/generated/erp/db/types/tables/vatCode";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SalesPartEditApi {
	export async function getInitData(args: {
		partId: number | null | undefined;
		salesPartId: number | null | undefined;
	}): Promise<SalesPartEditApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/salesPartEdit/getInitData",
			method: "POST",
			data: {
				partId: args.partId,
				salesPartId: args.salesPartId,
			},
		});
		return response as SalesPartEditApi_InitData;
	}

	export async function setToDefaultSalesPart(args: { salesPartId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/salesPartEdit/setToDefaultSalesPart",
			method: "POST",
			data: {
				salesPartId: args.salesPartId,
			},
		});
		return response as void;
	}

	export async function insert(args: {
		salesPart: SalesPart;
		importCodes: Array<SalesPartEditApi_ImportCodeSaveDto>;
		accountingCodeIds: Array<number>;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/salesPartEdit/insert",
			method: "POST",
			data: {
				salesPart: args.salesPart,
				importCodes: args.importCodes,
				accountingCodeIds: args.accountingCodeIds,
			},
		});
		return response as number;
	}

	export async function update(args: {
		request: SalesPartUpdateService_UpdateRequest;
		accountingCodeIds: Array<number>;
		importCodes: Array<SalesPartEditApi_ImportCodeSaveDto>;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/salesPartEdit/update",
			method: "POST",
			data: {
				request: args.request,
				accountingCodeIds: args.accountingCodeIds,
				importCodes: args.importCodes,
			},
		});
		return response as number;
	}

	export async function delete_(args: { salesPartId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/salesPartEdit/delete",
			method: "POST",
			data: {
				salesPartId: args.salesPartId,
			},
		});
		return response as void;
	}
}

export interface SalesPartEditApi_InitData {
	accountingDimensions: Array<ObjectAccountingDimensionValue>;
	erpUnitOptions: Array<ErpUnit>;
	importCodes: Array<SalesPartImportCode>;
	part: PartView | null | undefined;
	salesPart: SalesPart | null | undefined;
	salesPartCategoryOptions: Array<SalesPartCategory>;
	salesPriceGroupOptions: Array<SalesPartPriceGroup>;
	siteOptions: Array<Site>;
	vatCodeOptions: Array<VatCode>;
}

export interface SalesPartEditApi_ImportCodeSaveDto {
	importCode: string;
}
